module.exports = app_supply_protool_embeddable_listing_widget;